import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/lib/utils";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { MapPin, Plus, Search } from "lucide-react";
import { useState } from "react";
import { useIsAdmin } from "@/lib/hooks/useIsAdmin";
import { trpc } from "@/router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function UpptackView() {
  const $ = _c(29);
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const isAdmin = useIsAdmin();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.experiences.categories.withExperiences.queryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: categories
  } = useQuery(t0);
  let t1;
  if ($[1] !== activeCategory) {
    t1 = trpc.experiences.public.queryOptions({
      categoryId: activeCategory
    });
    $[1] = activeCategory;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: experiences,
    isLoading
  } = useQuery(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[3] !== activeCategory || $[4] !== categories || $[5] !== experiences || $[6] !== isLoading || $[7] !== searchQuery) {
    const parentCategories = categories?.filter(_temp) ?? [];
    const filteredExperiences = experiences?.filter(exp => {
      if (!searchQuery) {
        return true;
      }
      const q = searchQuery.toLowerCase();
      return exp.title.toLowerCase().includes(q) || exp.subtitle?.toLowerCase().includes(q) || exp.description?.toLowerCase().includes(q);
    });
    t2 = "container mx-auto px-4 py-8";
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /*#__PURE__*/_jsxs("div", {
        className: "mb-8",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-3xl font-bold text-gray-900 md:text-4xl",
          children: "Uppt\xE4ck tillg\xE4ngliga platser & upplevelser"
        }), /*#__PURE__*/_jsx("p", {
          className: "mt-2 text-lg text-gray-600",
          children: "Hitta aktiviteter, restauranger, parker och platser som \xE4r anpassade f\xF6r alla \u2014 oavsett funktionsf\xF6rm\xE5ga."
        })]
      });
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = /*#__PURE__*/_jsx(Search, {
        className: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
      });
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = e => setSearchQuery(e.target.value);
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    if ($[17] !== searchQuery) {
      t4 = /*#__PURE__*/_jsx("div", {
        className: "mb-6 flex gap-3",
        children: /*#__PURE__*/_jsxs("div", {
          className: "relative flex-1",
          children: [t8, /*#__PURE__*/_jsx("input", {
            type: "text",
            placeholder: "S\xF6k efter upplevelser, platser, aktiviteter...",
            value: searchQuery,
            onChange: t9,
            className: "w-full rounded-lg border border-gray-300 py-2.5 pl-10 pr-4 text-sm focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20"
          })]
        })
      });
      $[17] = searchQuery;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t5 = parentCategories.length > 0 && /*#__PURE__*/_jsxs("div", {
      className: "mb-6 flex flex-wrap gap-2",
      children: [/*#__PURE__*/_jsx("button", {
        onClick: () => setActiveCategory(null),
        className: cn("rounded-full border px-3 py-1.5 text-sm font-medium transition-colors", activeCategory === null ? "border-brand bg-brand/10 text-brand" : "border-gray-300 text-gray-600 hover:border-brand/50 hover:text-brand"),
        children: "Alla"
      }), parentCategories.map(cat => /*#__PURE__*/_jsx("button", {
        onClick: () => setActiveCategory(cat.id),
        className: cn("rounded-full border px-3 py-1.5 text-sm font-medium transition-colors", activeCategory === cat.id ? "border-brand bg-brand/10 text-brand" : "border-gray-300 text-gray-600 hover:border-brand/50 hover:text-brand"),
        children: cat.name
      }, cat.id))]
    });
    t6 = !isLoading && /*#__PURE__*/_jsx("div", {
      className: "mb-4",
      children: /*#__PURE__*/_jsxs("p", {
        className: "text-sm text-gray-500",
        children: ["Visar ", filteredExperiences?.length ?? 0, " upplevelser"]
      })
    });
    t7 = isLoading ? /*#__PURE__*/_jsx("div", {
      className: "grid gap-4 sm:grid-cols-2 lg:grid-cols-3",
      children: [1, 2, 3].map(_temp2)
    }) : filteredExperiences && filteredExperiences.length > 0 ? /*#__PURE__*/_jsx("div", {
      className: "grid gap-4 sm:grid-cols-2 lg:grid-cols-3",
      children: filteredExperiences.map(_temp3)
    }) : /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center justify-center py-16 text-gray-400",
      children: [/*#__PURE__*/_jsx(Search, {
        className: "mb-3 h-10 w-10"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-lg font-medium",
        children: "Inga upplevelser hittades"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-sm",
        children: "Prova att \xE4ndra s\xF6kord eller filter"
      })]
    });
    $[3] = activeCategory;
    $[4] = categories;
    $[5] = experiences;
    $[6] = isLoading;
    $[7] = searchQuery;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[19] !== isAdmin) {
    t8 = isAdmin && /*#__PURE__*/_jsx(Link, {
      to: "/upptack/redigera/$slug",
      params: {
        slug: "ny"
      },
      className: "fixed bottom-6 right-6 flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white shadow-lg transition-transform hover:scale-105",
      children: /*#__PURE__*/_jsx(Plus, {
        className: "h-6 w-6"
      })
    });
    $[19] = isAdmin;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: t2,
      children: [t3, t4, t5, t6, t7, t8]
    });
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp3(exp_0) {
  return /*#__PURE__*/_jsx(ExperienceCard, {
    experience: exp_0
  }, exp_0.id);
}
function _temp2(i) {
  return /*#__PURE__*/_jsxs("div", {
    className: "overflow-hidden rounded-xl border",
    children: [/*#__PURE__*/_jsx("div", {
      className: "aspect-[2/1] animate-pulse bg-gray-200"
    }), /*#__PURE__*/_jsxs("div", {
      className: "space-y-3 p-4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "h-5 w-3/4 animate-pulse rounded bg-gray-200"
      }), /*#__PURE__*/_jsx("div", {
        className: "h-4 w-1/2 animate-pulse rounded bg-gray-100"
      }), /*#__PURE__*/_jsx("div", {
        className: "h-4 w-full animate-pulse rounded bg-gray-100"
      })]
    })]
  }, i);
}
function _temp(c) {
  return c.parentId === null;
}
function ExperienceCard(t0) {
  const $ = _c(26);
  const {
    experience
  } = t0;
  let t1;
  if ($[0] !== experience.media) {
    t1 = experience.media?.find(_temp4);
    $[0] = experience.media;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const primaryImage = t1;
  const anyImage = experience.media?.[0];
  const image = primaryImage || anyImage;
  const slug = experience.titleSlug ?? experience.id;
  let t2;
  if ($[2] !== slug) {
    t2 = {
      slug
    };
    $[2] = slug;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== experience.title || $[5] !== image) {
    t3 = image ? /*#__PURE__*/_jsx("div", {
      className: "aspect-[2/1] overflow-hidden bg-gray-100",
      children: /*#__PURE__*/_jsx("img", {
        src: image.url,
        alt: image.altText ?? experience.title,
        className: "h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
      })
    }) : /*#__PURE__*/_jsx("div", {
      className: "flex aspect-[2/1] items-center justify-center bg-brand/5",
      children: /*#__PURE__*/_jsx(MapPin, {
        className: "h-10 w-10 text-brand/30"
      })
    });
    $[4] = experience.title;
    $[5] = image;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== experience.placeId) {
    t4 = experience.placeId && /*#__PURE__*/_jsxs("span", {
      className: "absolute bottom-2 left-2 flex items-center gap-1 rounded-full bg-white/90 px-2 py-0.5 text-[10px] font-medium text-gray-700 shadow-sm backdrop-blur-sm",
      children: [/*#__PURE__*/_jsx(MapPin, {
        className: "h-3 w-3 text-brand"
      }), "Tillg\xE4nglighetsinfo"]
    });
    $[7] = experience.placeId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [t3, t4]
    });
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== experience.title) {
    t6 = /*#__PURE__*/_jsx("h3", {
      className: "mb-1 text-lg font-semibold text-gray-900",
      children: experience.title
    });
    $[12] = experience.title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== experience.subtitle) {
    t7 = experience.subtitle && /*#__PURE__*/_jsx("p", {
      className: "mb-2 text-sm font-medium text-brand",
      children: experience.subtitle
    });
    $[14] = experience.subtitle;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== experience.description) {
    t8 = experience.description && /*#__PURE__*/_jsx("p", {
      className: "line-clamp-2 text-sm text-gray-600",
      children: experience.description
    });
    $[16] = experience.description;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: "p-4",
      children: [t6, t7, t8]
    });
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t2 || $[23] !== t5 || $[24] !== t9) {
    t10 = /*#__PURE__*/_jsxs(Link, {
      to: "/upptack/$slug",
      params: t2,
      className: "group block overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md",
      children: [t5, t9]
    });
    $[22] = t2;
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp4(m) {
  return m.isPrimary;
}